export default "__VITE_ASSET__D7Dx_JKs__"